var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGt = function SvgGt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M24 12a12 12 0 0 0-6.783-10.81v21.62A12 12 0 0 0 23.999 12ZM0 12a12 12 0 0 0 6.783 10.81V1.19A12 12 0 0 0 0 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACABB1",
    d: "M15.135 14.028 13.106 12l1.931-1.931-.087-1.02-.553-.553-2.398 2.398-2.398-2.398-.553.553-.087 1.02 1.931 1.931-2.029 2.03 1.107 1.106L12 13.106l2.028 2.03 1.107-1.108Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "m14.951 9.049-1.106 1.107a2.609 2.609 0 1 1-3.69 0L9.05 9.049a4.174 4.174 0 1 0 5.903 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGt;